export default __webpack_public_path__ + "static/media/baton_large.5d795980.png";